import React, { useEffect } from 'react';
import LandingPage from './components/landing/LandingPage';
import { APP_URL } from './config';
import './styles.css';

// Existing users who pinned vesna.health to their home screen as a PWA
// (before the domain split) still launch into this origin. Bounce them
// straight to the app instead of showing marketing content they can't
// easily click through from a standalone window.
const isStandaloneLaunch = () =>
  window.navigator.standalone === true ||
  window.matchMedia('(display-mode: standalone)').matches;

function App() {
  const standalone = isStandaloneLaunch();

  useEffect(() => {
    if (standalone) window.location.replace(APP_URL);
  }, [standalone]);

  if (standalone) return null;

  return <LandingPage />;
}

export default App;
